module.exports = __webpack_public_path__ + "media/assets/images/cvv-b2b7fa33b9de808415c1232b529da08f.png";